export const COLUMN_IDS = {
  STT: 'index',
  LOCATION_NAME: 'locationName',
  TYPE_DESCRIPTION: 'TYPE_DESCRIPTION',
  NUMBER_OF_COMPANIES: 'numberCompanies',
  PERCENT_OF_TOTAL_COMPANIES: 'percentCompanies',
  CREDIT_RISK_SCORE: 'creditRiskScore',
  PERFORMANCE_SCORE: 'performanceScore',
}

export const TITLE_TABLE_SCORE_TREND = [
  {
    title: '#',
    key: COLUMN_IDS.STT,
    thStyle: {
      justifyContent: 'start',
    },
    tdStyle: { minWidth: 60 },
  },
  {
    title: 'portfolio.summary.PROVINCE',
    key: COLUMN_IDS.LOCATION_NAME,
    thStyle: {
      justifyContent: 'start',
    },
    tdStyle: { width: '100%', maxWidth: 0 },
  },

  {
    title: 'portfolio.segment.NUMBER_OF_COMPANIES',
    key: COLUMN_IDS.NUMBER_OF_COMPANIES,
    thStyle: {
      justifyContent: 'end',
    },
    tdStyle: {
      textAlign: 'right',
      minWidth: 180,
    },
    isChangeTitle: true,
  },

  {
    title: 'portfolio.segment.PERCENT_OF_TOTAL_COMPANIES',
    key: COLUMN_IDS.PERCENT_OF_TOTAL_COMPANIES,
    thStyle: {
      justifyContent: 'end',
      textAlign: 'right',
    },
    tdStyle: {
      textAlign: 'right',
      minWidth: 180,
    },
  },
  {
    title: 'portfolio.segment.CREDIT_RISK_SCORE',
    key: COLUMN_IDS.CREDIT_RISK_SCORE,
    thStyle: {
      justifyContent: 'end',
    },
    tdStyle: {
      textAlign: 'right',
      minWidth: 180,
    },
    isChangeTitle: true,
  },
]

export const CREDIT_RISK_COL = {
  title: 'portfolio.segment.CREDIT_RISK_SCORE',
  key: COLUMN_IDS.CREDIT_RISK_SCORE,
  thStyle: {
    justifyContent: 'end',
  },
  tdStyle: {
    textAlign: 'right',
    minWidth: 180,
  },
  isChangeTitle: true,
}
